<template>
	<div class="full">
		<div class="full zhe">
			<div class="rule_bg">
				<div class="full"><img src="../img/rule_bg.png" /></div>
				<div class="rule_content">
					<img  src="../img/rule_content.png"/>
				</div>
				<div class="rule_back" v-hammer:tap="ruleBack"></div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	.rule_bg {
		position: absolute;
		width: 79.1%;
		height: 65.6%;
		left: 10.5%;
		top: 15.9%;
	}

	.rule_content {
		position: absolute;
		width: 65.2%;
		height: 63.8%;
		left: 18.4%;
		top: 16.7%;
		overflow: auto;
	}

	.rule_back {
		position: absolute;
		width: 10.8%;
		height: 6.8%;
		left: 44.6%;
		top: 93.2%;
	}

	.rabbit1 {
		-webkit-animation: rabbit1 .5s linear forwards;
	}

	@-webkit-keyframes rabbit1 {
		0% {
			-webkit-transform: translate(60px, 60px);
			opacity: 0;
		}

		100% {
			-webkit-transform: translate(0, 0);
			opacity: 1;
		}
	}

	.rabbit2 {
		-webkit-animation: rabbit2 .5s linear forwards;
	}

	@-webkit-keyframes rabbit2 {
		0% {
			-webkit-transform: translate(-60px, 60px);
			opacity: 0;
		}

		100% {
			-webkit-transform: translate(0, 0);
			opacity: 1;
		}
	}
</style>
<script>
	export default {
		data() {
			return {
				nextBuff: false,
				ruleShow: false
			};
		},
		computed: {

		},
		mounted() {

		},
		watch: {

		},
		methods: {
			ruleBack() {
				this.$emit('ruleBack')
			}
		},
		components: {

		}
	}
</script>
